export enum ToasterType {
  // Need to be lowercase because they are used in scss
  Default = 'default',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}
